
export default {
};



// WEBPACK FOOTER //
// ./src/store/modules/favourites/getters.js